//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import Swal from 'sweetalert2';

//-================ IMPORTS FOR INTERFACES ================-\\
import { Header_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Header_FIN.interface';

@Component({
    selector: 'app-edit-headers-master',
    templateUrl: './edit-headers-master.component.html',
    styleUrls: [
        './edit-headers-master.component.scss',
        '../../../../Styles/GlobalStyles.css',
        '../../../../Styles/HeaderGlobal.css'
    ],

    standalone: false
})
export class EditHeadersMasterComponent implements OnInit {

    private ServiceMaster = inject(LibraryMasterService);
    private Route = inject(ActivatedRoute);

    //-========================= SECTION VARIABLES =========================-\\

    private ColorConfirm: string = '#20a8e1';
    private ColorsCancel: string  = '#fc6161';

    public libSlug: string = '';
    public libTitle: string = '';
    public Lib_Headers: Header_FIN[] = [];

    ngOnInit(): void {
        // Read libSlug from the route param ':libSlug'
        this.Route.paramMap.subscribe(params => {
            this.libSlug = params.get('libSlug') || '';
            this.libTitle = this.libSlug.toUpperCase();
            this.Load_Component();
        });
    }

    //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

    private async Load_Component(): Promise<void> {
        if (!this.libSlug) return;

        const Loader = document.getElementById('Loader') as HTMLDivElement;
        Loader.classList.add('active');

        try {
            const Res = await firstValueFrom(this.ServiceMaster.Get_Headers_Edit(this.libSlug));

            if (Res.success) {
                this.Lib_Headers = Res.operation;
            } else {
                throw new Error('Failed to load headers');
            }
        } catch (e) {
            Swal.fire({
                title: 'Ocurrió un error',
                text: '¡Notifique este error al supervisor!',
                icon: 'warning',
                confirmButtonColor: this.ColorConfirm
            });
        } finally {
            Loader.classList.remove('active');
        }
    }

    //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

    public drop(event: CdkDragDrop<any[]>): void {
        moveItemInArray(this.Lib_Headers, event.previousIndex, event.currentIndex);
    }

    //&===================== FUNCTIONS FOR SAVE CHANGES IN HEADERS =====================&\\

    public SaveHeaders(): void {
        Swal.fire({
            title: `¿Desea guardar los cambios de las cabeceras de ${this.libTitle}?`,
            text: '¡Modificará el orden y los nombres en caso de que haya hecho cambios!',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, guardar',
            cancelButtonText: 'No, Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    for (let i = 0; i < this.Lib_Headers.length; i++) {
                        this.Lib_Headers[i].Position = i;
                    }

                    const ResUpdate: any = await firstValueFrom(
                        this.ServiceMaster.Edit_Headers(this.libSlug, this.Lib_Headers)
                    );

                    if (ResUpdate.success) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Cabeceras modificadas correctamente',
                            confirmButtonColor: this.ColorConfirm
                        });
                    } else {
                        throw new Error('Update returned failure');
                    }
                } catch (e) {
                    Swal.fire({
                        title: 'Ocurrió un error',
                        text: '¡Ocurrió un error al actualizar las cabeceras, si el problema persiste notifique a supervisor!',
                        icon: 'warning',
                        confirmButtonColor: this.ColorConfirm
                    });
                }

                this.Load_Component();
            }
        });
    }
}
